export const ENTRYPOINT = process.env.REACT_APP_API_ENTRYPOINT;
export const APP_SITE_ID = process.env.REACT_APP_SITE_ID || '';
export const HOMEPAGE_URL = process.env.REACT_APP_HOMEPAGE_URL;
